export const RESET_CHAPS_DAILY_LIMIT_AUTHORISATION = 'CHAPS/RESET_CHAPS_DAILY_LIMIT_AUTHORISATION';
export const resetChapsDailyLimitAuthorisation = () => ({ type: RESET_CHAPS_DAILY_LIMIT_AUTHORISATION });
